import ManualOrderPage from "../components/orders/manualOrder";
import ManualOrder from "../components/orders/manualOrder";
import OpenOrders from "../components/orders/openOrdersList";
import OrderDetails from "../components/orders/OrderDetails";
import OrdersIndex from "../components/orders/OrderList";
import AddCustomerPage from "../pages/call center/addCallCenter";
import CustomerIndexPage from "../pages/call center/callCenter";
import EditCustomerPage from "../pages/call center/editCallCenter";


const orderRoutes = [
  {
    path: "orders",
    element: <OrdersIndex />,
  },
  {
    path: "open-orders",
    element: <OpenOrders />,
  },
  
  {
    path: "orders/add",
    element: <ManualOrderPage />,
  },
  {
    path: "orders/:id",
    element: <OrderDetails />,
  },
  {
    path: "call_center",
    element: <CustomerIndexPage />,
  },
  {
    path: "call_center/add",
    element: <AddCustomerPage />,
  },
  {
    path: "call_center/edit/:id",
    element: <EditCustomerPage />,
  },
  
];

export default orderRoutes;